/*=========================================================================================
  File Name: moduleVehicleMutations.js
  Description: Category Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_VEHICLE(state, item) {
		state.vehicles.unshift(item);
	},
	SET_VEHICLES(state, items) {
		state.vehicles = [...items];
	},
	UPDATE_VEHICLE(state, payload) {
		const vehicleIndex = state.vehicles.findIndex((vh) => vh.id === payload.id);
		if (vehicleIndex !== -1) {
			Object.assign(state.vehicles[vehicleIndex], payload);
		}
	},
	REMOVE_VEHICLE(state, itemId) {
		const ItemIndex = state.vehicles.findIndex((vh) => vh.id === itemId);
		state.vehicles.splice(ItemIndex, 1);
	},
	REMOVE_ALL_VEHICLES(state) {
		state.vehicles = [];
	},
	SET_ASSIGNED_VEHICLE(state, items) {
		let arrayNew = state.assignedVehicles.concat(
			items.filter((element) => state.assignedVehicles.find((e) => e.id === element.id) === undefined)
		);
		state.assignedVehicles = arrayNew;
	},
	REMOVE_ASSIGNED_VEHICLE(state, itemId) {
		const ItemIndex = state.assignedVehicles.findIndex((p) => p.id === itemId);
		state.assignedVehicles.splice(ItemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_VEHICLE(state) {
		state.assignedVehicles = [];
	},
	ADD_VEHICLE_CHECKED(state, item) {
		const itemIndex = state.checkedVehicles.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedVehicles.push(item);
		}
	},
	SET_VEHICLE_CHECKED(state, payload) {
		state.checkedVehicles = payload;
	},
	REMOVE_VEHICLE_CHECKED(state, item) {
		const itemIndex = state.checkedVehicles.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedVehicles.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VEHICLE_CHECKED(state) {
		state.checkedVehicles = [];
	},
	SELECTED_VEHICLE(state, payload) {
		if (payload) {
			state.currentVehicleId = payload.id !== undefined ? payload.id : 0;
			state.currentVehicle = payload;
		} else {
			state.currentVehicle = {};
			state.currentVehicleId = 0;
		}
	},
	SET_DEPOSIT_INIT(state, depositInit) {
		state.depotInfoInit = depositInit;
	},
	SET_DEPOSIT_END(state, depositEnd) {
		state.depotInfoEnd = depositEnd;
	},
	SET_DATARUTAS_RESOURCE(state, items) {
		state.resourceListDatarutas = [...items];
	},
	ADD_VEHICLE_CHECKED_DATARUTAS(state, item) {
		const itemIndex = state.checkedResourceDatarutas.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedResourceDatarutas.push(item);
		}
	},
	REMOVE_VEHICLE_CHECKED_DATARUTAS(state, item) {
		const itemIndex = state.checkedResourceDatarutas.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedResourceDatarutas.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_VEHICLE_CHECKED_DATARUTAS(state) {
		state.checkedResourceDatarutas = [];
	},
	SET_UPLOAD_FILE_VEHICLE(state, items) {
		state.uploadFileList.push(items);
	},
	REMOVE_UPLOAD_FILE_VEHICLE(state, item) {
		const itemIndex = state.uploadFileList.findIndex((p) => p.bucket_path === item.bucket_path);
		if (itemIndex >= 0) {
			state.uploadFileList.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_UPLOAD_FILE_VEHICLE(state) {
		state.uploadFileList = [];
	},
	ADD_CHECKED_UPLOAD_FILE_VEHICLE(state, item) {
		state.checkedUploadFiles.push(item);
	},
	REMOVE_CHECKED_UPLOAD_FILE_VEHICLE(state, item) {
		const itemIndex = state.checkedUploadFiles.findIndex((p) => p.bucket_path === item.bucket_path);
		if (itemIndex >= 0) {
			state.checkedUploadFiles.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_CHECKED_UPLOAD_FILE_VEHICLE(state) {
		state.checkedUploadFiles = [];
	},
};
